import { Component, OnInit } from '@angular/core';
import { AppConstant } from 'src/app/helper/class/app-constant';

@Component({
  selector: 'app-user-footer',
  templateUrl: './user-footer.component.html',
  styleUrls: ['./user-footer.component.scss']
})
export class UserFooterComponent implements OnInit {
  logo = AppConstant.LOGO_SRC;
  year = new Date().getFullYear()
  constructor() { }

  ngOnInit(): void {
  }

}
